import { Avatar, Box, Chip, IconButton, Menu, MenuItem, Stack, TextField, Typography } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import React, { useEffect, useState } from "react";
import { useThemeMode } from "../../components/theme/index.jsx";
import { colours as constColours, CustomTooltip } from "../../consts.js";
import { THEME_MODES } from "../../helpers/constant.js";
import { removeDetectKeywordFromVisuals } from "../../helpers/index.js";

function MessageRow({ input, output, tagsMode, id, filter }) {
    const { colours, FONT } = useThemeMode();
    function capcase(input) {
        return input.charAt(0).toUpperCase() + input.slice(1);
    }
    const [editmode, setEditmode] = useState(false);
    const [editCommentMode, setEditCommentMode] = useState(false);
    const [text, setText] = useState("");
    const [bm, setBm] = useState([]);
    const [comment, setComment] = useState("");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        if (typeof event === "string") changebm(event);
        setAnchorEl(null);
    };

    function changebm(val) {
        let newbm = Object.assign([], bm);
        if (bm.indexOf(val) > -1) newbm = bm.filter((z) => z !== val);
        else newbm.push(val);
        setBm(newbm);
        output({ func: "setbm", message: input.id, bm: newbm });
    }
    useEffect(() => {
        setText(input.text);
        setComment(input.comment);
        if (input.bm !== undefined) setBm(input.bm);
    }, []);

    function replacer(inputtxt, replacertxt) {
        if (!replacertxt) {
            return <div>{inputtxt}</div>;
        }

        replacertxt = JSON.parse(replacertxt);
        if (replacertxt.length === 0) return <div>{inputtxt}</div>;

        const keyword = replacertxt[0].text;
        const parts = (inputtxt + " ").split(keyword);

        return (
            <div>
                {parts.map((part, index) => (
                    <React.Fragment key={index}>
                        {part}
                        {index < parts.length - 1 && (
                            <Chip
                                label={keyword}
                                color="secondary"
                                size="small"
                                sx={(theme) => ({
                                    fontSize: { xs: FONT.SIZE_14, lg: FONT.SIZE_16 },
                                    p: .25,
                                    height: 'inherit',
                                    lineHeight: 1.25,
                                    color: theme.palette.mode === THEME_MODES.DARK && colours.black,
                                    '.MuiChip-label': {
                                        whiteSpace: 'normal',
                                    }
                                })}
                            />
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    if (filter === "Full" || filter.toUpperCase() === input.type.toUpperCase())
        return (
            <Stack
                direction="row"
                alignItems="center"
                flexWrap={{ xs: "wrap", md: "nowrap" }}
                id={id}
                sx={{
                    width: "100%",
                    marginTop: '8px',
                }}
            >
                <Stack
                    direction="row"
                    flexWrap="wrap"
                    sx={{
                        width: { xs: "100%", md: "65%", lg: "80%" },
                    }}
                >
                    <Stack
                        direction="row"
                        flexWrap="wrap"
                        alignItems="start"
                        gap={1}
                        sx={{
                            width: "100%",
                        }}
                    >
                        <Stack
                            direction="row"
                            sx={{
                                width: { xs: "100%", lg: "80%" },
                            }}
                        >
                            {/* <div style={{ minWidth: input.type === "agent" ? 0 : 60 }} /> */}
                            <Box
                                sx={{
                                    paddingRight: 2,
                                    paddingLeft: input.type === "agent" ? 0 : { xs: 5.25, lg: 7.5 },
                                    flexShrink: 0,
                                }}
                            >
                                <Avatar
                                    sx={(theme) => ({
                                        ...colours.shadowMd,
                                        width: { xs: 30, lg: 40 },
                                        minWidth: { xs: 30, lg: 40 },
                                        height: { xs: 30, lg: 40 },
                                        background: input.type === "agent" ? colours.black : colours.purple100,
                                        borderRadius: " 22px",
                                        justifyContent: "center",
                                        color: (theme.palette.mode === THEME_MODES.DARK && input.type !== "agent") ? colours.black : colours.white,
                                        alignItems: "center",
                                        display: "flex",
                                        padding: .75,
                                        boxSizing: "border-box",
                                    })}
                                >
                                    <FeatherIcon icon={input.type === "agent" ? "headphones" : "user"} />
                                </Avatar>
                            </Box>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Typography component="div"
                                    sx={(theme) => ({
                                        background: theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black,
                                        border: input.type === "agent" ? `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.black}` : "",
                                        boxSizing: "border-box",
                                        boxShadow:
                                            input.type === "agent"
                                                ? `2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? '#D1D9E6' : colours.black}, 2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black}`
                                                : "",
                                        borderRadius: "0px 20px 20px 20px",
                                        display: "flex",
                                        flexDirection: "row",
                                        minWidth: "100%",
                                        padding: 1.25,
                                        alignItems: "center",
                                        fontSize: { xs: FONT.SIZE_14, lg: FONT.SIZE_16 }
                                    })}
                                >
                                    {editmode ? (
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth={true}
                                            size="small"
                                            multiline={true}
                                            value={text}
                                            onKeyDown={(e) => {
                                                if (e.keyCode === 13) {
                                                    output({
                                                        func: "settext",
                                                        message: input.id,
                                                        newtext: text,
                                                    });
                                                    setEditmode(!editmode);
                                                }
                                            }}
                                            onChange={(c) => {
                                                setText(c.target.value);
                                                // console.log({ old: text, new: c.target.value });
                                            }}
                                        />
                                    ) : (
                                        <>{replacer(text, input.phrases)}</>
                                    )}
                                </Typography>
                                {comment !== undefined || editCommentMode ? (
                                    <Typography component="div"
                                        sx={(theme) => ({
                                            background: theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black,
                                            border: `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.black}`,
                                            boxSizing: "border-box",
                                            boxShadow: `2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? '#D1D9E6' : colours.black}, 2px 2px 3px ${theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black}`,
                                            borderRadius: "0px 20px 20px 20px",
                                            display: "flex",
                                            flexDirection: "row",
                                            minWidth: "100%",
                                            // color: colours.white,
                                            padding: 1.25,
                                            alignItems: "center",
                                            margin: "4px 0",
                                            fontSize: { xs: FONT.SIZE_14, lg: FONT.SIZE_16 }
                                        })}
                                    >
                                        {editCommentMode ? (
                                            <TextField
                                                id="outlined-basic"
                                                fullWidth={true}
                                                size="small"
                                                multiline={true}
                                                label="Comment"
                                                variant="outlined"
                                                value={comment}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        output({
                                                            func: "setcomment",
                                                            message: input.id,
                                                            newtext: comment,
                                                        });
                                                        setEditCommentMode(!editCommentMode);
                                                    }
                                                }}
                                                onChange={(c) => setComment(c.target.value)}
                                            />
                                        ) : (
                                            comment
                                        )}
                                    </Typography>
                                ) : null}
                                {bm?.length > 0 &&
                                    <Stack direction="row" flexWrap="wrap" gap={.5} justifyContent="end" sx={{ margin: '8px 0' }}>
                                        {bm.map((bz, bzid) => (
                                            <Chip
                                                label={bz}
                                                key={bzid}
                                                color="default"
                                                avatar={
                                                    <FeatherIcon icon="bookmark" />
                                                }
                                            />
                                        ))}
                                    </Stack>
                                }
                            </div>
                        </Stack>

                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent={{ xs: "end", lg: "start" }}
                            gap={.5}
                            sx={{
                                width: { xs: '100%', lg: 116 },
                                order: { xs: '-1', lg: 'inherit' },
                                position: { xs: 'relative', lg: 'static' },
                                top: 0,
                                right: '12px',
                                marginTop: { xs: 2, lg: 1 },
                                marginBottom: { xs: .5, lg: 0 },
                            }}
                        >
                            <CustomTooltip title="Edit">
                                <IconButton
                                    aria-label="Edit"
                                    color="primary"
                                    sx={colours.shadowMd}
                                    onClick={() => {
                                        if (editmode)
                                            output({
                                                func: "settext",
                                                message: input.id,
                                                newtext: text,
                                            });
                                        setEditmode(!editmode);
                                    }}
                                >
                                    <FeatherIcon icon="edit" size={20} />
                                </IconButton>
                            </CustomTooltip>
                            <CustomTooltip title="Comment">
                                <IconButton
                                    aria-label="Comment"
                                    color="primary"
                                    sx={colours.shadowMd}
                                    onClick={() => {
                                        if (editCommentMode)
                                            output({
                                                func: "setcomment",
                                                message: input.id,
                                                newtext: comment,
                                            });
                                        setEditCommentMode(!editCommentMode);
                                    }}
                                >
                                    <FeatherIcon icon="message-square" size={20} />
                                </IconButton>
                            </CustomTooltip>
                            <div>
                                <CustomTooltip title="Bookmark">
                                    <IconButton
                                        aria-label="Bookmark"
                                        color="primary"
                                        sx={colours.shadowMd}
                                        id="basic-button"
                                        aria-controls={open ? "basic-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? "true" : undefined}
                                        onClick={handleClick}
                                    >
                                        <FeatherIcon icon="bookmark" size={20} />
                                    </IconButton>
                                </CustomTooltip>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        "aria-labelledby": "basic-button",
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => handleClose("WOW moments")}
                                    >
                                        WOW moments
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => handleClose("High risk")}
                                    >
                                        High risk
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => handleClose("Great interactions")}
                                    >
                                        Great interactions
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => handleClose("Poor interactions")}
                                    >
                                        Poor interactions
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => handleClose("Other")}
                                    >
                                        Other
                                    </MenuItem>
                                </Menu>
                            </div>
                        </Stack>

                    </Stack>
                </Stack>
                <Stack
                    direction="row"
                    flexWrap="wrap"
                    sx={{
                        width: { xs: "100%", md: "35%", lg: "20%" },
                        paddingLeft: { xs: input.type === "agent" ? 5.25 : 10.5, md: 2, lg: 0 },
                        paddingTop: { xs: 1, md: 0 },
                    }}
                >
                    {tagsMode === "trackers"
                        ? input.trackers
                            .filter((z) => z.id === input.id)
                            .map((z, zidx) => (
                                <Chip
                                    color="default"
                                    key={zidx}
                                    label={capcase(removeDetectKeywordFromVisuals(z.name))}
                                />
                            ))
                        : null}
                    {tagsMode === "alerts"
                        ? input.trackers
                            .filter((z) => z.alert)
                            .filter((z) => z.id === input.id)
                            .map((z, zidx) => (
                                <Chip
                                    color="default"
                                    key={zidx}
                                    label={capcase(removeDetectKeywordFromVisuals(z.name))}
                                />
                            ))
                        : null}
                    {tagsMode === "topics"
                        ? input.topics
                            .filter((z) => z.id === input.id)
                            .map((z, zidx) => (
                                <Chip
                                    color="default"
                                    key={zidx}
                                    label={capcase(z.name)}
                                />
                            ))
                        : null}
                </Stack>
            </Stack>
        );
    else return null;
}

export default MessageRow;